/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const SearchOrangeIcon: React.SFC<any> = (props: any) => {
    return (
        <svg width="24px" height="27px">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Nav-/-icon-/-search" stroke={props.color ? props.color : `#F07662`} strokeWidth="2">
                    <circle id="Oval" cx="9" cy="11" r="8" />
                    <path d="M16,18 L21.8206758,23.8206758" id="Line" strokeLinecap="round" />
                </g>
            </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Search/SearchOrange.tsx